// extracted by mini-css-extract-plugin
module.exports = {"submitBtn":"PaymentLogSubmitForm_submitBtn__3gYxE","savePaymentMethod":"PaymentLogSubmitForm_savePaymentMethod__9P-xA"};